/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Olive_Swift_Mole_LurkInputs */

const en_olive_swift_mole_lurk = /** @type {(inputs: Olive_Swift_Mole_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple`)
};

const de_olive_swift_mole_lurk = /** @type {(inputs: Olive_Swift_Mole_LurkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterschiedlich`)
};

/**
* | output |
* | --- |
* | "Multiple" |
*
* @param {Olive_Swift_Mole_LurkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const olive_swift_mole_lurk = /** @type {((inputs?: Olive_Swift_Mole_LurkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Olive_Swift_Mole_LurkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_olive_swift_mole_lurk(inputs)
	return de_olive_swift_mole_lurk(inputs)
});